import React from 'react';
import './PageLoader.css';

/**
 * Single loading interface used everywhere in the app.
 *
 * Variants:
 *   - "full"   — full-viewport overlay. Use for route-level loading
 *                (auth check, fetching the whole page before chrome).
 *   - "block"  — centered inside its container, ~60vh tall. Use for
 *                sections of a page that load independently.
 *   - "inline" — small horizontal spinner + label. Use inside buttons
 *                or within text flow.
 *
 * Props:
 *   variant: "full" | "block" | "inline" (default "block")
 *   label:   string — optional message under the spinner
 *   sub:     string — optional small tag below the label for context
 *                     (e.g. "Admin", "Stripe"). Rendered subtly.
 *
 * Quick loads (< ~250ms) don't visually flash a spinner — the CSS
 * fade-in is delayed and skipped if the component unmounts first.
 */
export default function PageLoader({ variant = 'block', label, sub, className = '' }) {
  return (
    <div className={`pl pl-${variant} ${className}`} role="status" aria-live="polite">
      <div className="pl-spinner" aria-hidden="true">
        <svg className="pl-ring" viewBox="0 0 40 40">
          <circle cx="20" cy="20" r="16" fill="none" />
        </svg>
        <svg className="pl-arc" viewBox="0 0 40 40">
          <circle cx="20" cy="20" r="16" fill="none" />
        </svg>
      </div>
      {label && <p className="pl-label">{label}</p>}
      {sub && <span className="pl-sub">{sub}</span>}
    </div>
  );
}
